import {
  Box,
  Button,
  FormGroup,
  FormHelperText,
  makeStyles,
  MenuItem,
  TextField,
} from '@material-ui/core'
import React from 'react'
import { Trash } from 'react-feather'
import { Control, FieldError, useFieldArray } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { validators } from '../../validation/validators'
import { ControlledTextField } from './ControlledTextField'
import type { UpdatePartFormValue } from '../building/basic-info-dialog/form-values'

const useStyles = makeStyles((theme) => ({
  dropdown: {
    width: '60%',
    marginRight: theme.spacing(2),
  },
}))

type UpdateProps = {
  control: Control
  name: string
  error?: FieldError
}

export function ControlledUpdatePartsEditor(
  props: UpdateProps,
): React.ReactElement {
  const { control, name, error } = props

  const { fields: parts, remove } = useFieldArray<UpdatePartFormValue, 'key'>({
    keyName: 'key',
    control,
    name,
  })

  const classes = useStyles()
  const { t } = useTranslation()

  const templateOptions = parts.map((part) => (
    <MenuItem key={part.id} value={part.name}>
      {part.name}
    </MenuItem>
  ))

  return (
    <Box id={`part-editor-${name}`}>
      {parts.map((part, index) => (
        <Box key={part.key} display="flex" flexDirection="row" py={2}>
          <Box display="none">
            <ControlledTextField
              control={control}
              name={`${name}.${index}.id`}
              defaultValue={part.id}
            />
          </Box>

          <FormGroup className={classes.dropdown}>
            <TextField
              name={`${name}.${index}.name`}
              defaultValue={part.name}
              type="text"
              label={t('createBuilding.pages.parts.partsDropdownLabel')}
              select
              disabled
            >
              {templateOptions}
            </TextField>
          </FormGroup>

          <FormGroup>
            <ControlledTextField
              control={control}
              name={`${name}.${index}.area`}
              defaultValue={part.area}
              rules={validators.required}
              type="number"
              label={t('createBuilding.pages.parts.partArea')}
            />
          </FormGroup>

          <Button onClick={() => remove(index)}>
            <Trash />
          </Button>
        </Box>
      ))}

      {error && <FormHelperText error>{error}</FormHelperText>}
    </Box>
  )
}
